window.mcb.modalizer = (function () {
    const closeModal = function (element) {
        const modal = element.closest('.mcb-modal');
        modal.classList.add('closing');
        modal.classList.remove('show');

        setTimeout(() => {
            modal.classList.remove('closing');
        }, 500);

        modal.dispatchEvent(new CustomEvent('MCB.Events.Modal.Closed', {
            'detail': {
                modal
            }
        }));
    }

    const wrap = function (element, classes, title = null) {
        if (element) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('mcb-modal');
            if (classes) {
                wrapper.classList.add(...classes);
            }

            element.parentNode.insertBefore(wrapper, element);

            const container = document.createElement('div');
            container.classList.add('mcb-modal-container');
            wrapper.appendChild(container);

            const controls = document.createElement('div');
            controls.classList.add('mpa-wp-controls');
            container.appendChild(controls);

            const close = document.createElement('input');
            close.type = 'button';
            close.value = 'x';
            close.classList.add('mpa-button');
            close.addEventListener('click', function (event) {
                event.preventDefault();
                closeModal(event.target);
            });
            controls.appendChild(close);

            if (title) {
                const header = document.createElement('h2');
                header.innerText = title;
                header.classList.add('mcb-modal-header');
                container.appendChild(header);
            }

            const body = document.createElement('div');
            body.classList.add('mcb-modal-body');
            body.appendChild(element);
            container.appendChild(body);

            return wrapper;
        }

        return null;
    }

    return {
        wrap: wrap,
        openModal: function (element) {
            const modal = element.closest('.mcb-modal');
            if (modal) {
                modal.classList.add('show');
            }

            modal.dispatchEvent(new CustomEvent('MCB.Events.Modal.Opened', {
                'detail': {
                    modal
                }
            }));
        },
        closeModal: closeModal
    }
})();
